import { IconButton } from '@creditornot/cb-button';
import { CopyPaste, Checkmark } from '@creditornot/cb-icons';
import { cbSemanticCssVars, Typography } from '@creditornot/cb-ingredients';
import { Popover } from '@creditornot/cb-popover';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export type CopyCampaignIdProps = {
  campaignId: string;
  dataTestId: string;
};

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-block-start: 96px;
`;

const StyledText = styled(Typography.Body3)`
  color: ${cbSemanticCssVars.textSecondary};
`;

const CopyCampaignIdButton = ({ campaignId, dataTestId }: CopyCampaignIdProps) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const handleCopy = async () => {
    await window.navigator.clipboard.writeText(campaignId);
    setIsDisabled(true);

    setTimeout(async () => {
      setIsDisabled(false);
    }, 2000);
  };

  return (
    <StyledWrapper data-testid={dataTestId}>
      <StyledText>
        <FormattedMessage id="campaigns.campaign-id.label" values={{ campaignId }} />
      </StyledText>

      <Popover
        content={<FormattedMessage id="campaigns.campaign-id.success-copy" />}
        placement="right"
        show={isDisabled}
        showOnHover={false}
      >
        <IconButton size="tiny" variant="blue" onClick={handleCopy} disabled={isDisabled}>
          {isDisabled ? <Checkmark /> : <CopyPaste />}
        </IconButton>
      </Popover>
    </StyledWrapper>
  );
};

export default CopyCampaignIdButton;
